/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
ActionContainer.displayName = 'ActionContainer';
